/**
 * Copyright (c) Microsoft. All rights reserved.
 */
import * as React from 'react';
/**
 * This hook wraps a callback function passed to the labeler and received an annotation data as parameter,
 * and that's to update the annotation token ranges using the token-to-char map calculated after getting line infos.
 *
 * @param tokenToCharMap token-to-char map that maps each token index
 *  to the start and the end indices of the token in the real text
 * @param callback the callback passed to the labeler to wrap.
 * @returns the wrapped callback after updating annotation token ranges.
 */
export const useAnnotationIndexConverter = (tokenToCharMap, callback) => React.useCallback((annotation, ...args) => {
    var _a, _b;
    return callback(Object.assign(Object.assign({}, annotation), { endToken: (_a = tokenToCharMap.get(annotation.endToken)) === null || _a === void 0 ? void 0 : _a.endIndex, startToken: (_b = tokenToCharMap.get(annotation.startToken)) === null || _b === void 0 ? void 0 : _b.startIndex }), ...args);
}, [callback, tokenToCharMap]);
